import { Loader } from 'app/components/Loader';
import React, {createContext, useContext, useState} from 'react';

const LoaderContext = createContext({});

export function LoaderProvider ({ children }) {

    const [isLoaderVisible, setIsLoaderVisible] = useState(false);

    function show() {
        setIsLoaderVisible(true);
    }

    function hide() {
        setIsLoaderVisible(false);
    }

    return (
        <LoaderContext.Provider value={{ show, hide }}>

            {children}

            <Loader isVisible={isLoaderVisible} />
        </LoaderContext.Provider>
    );
}

export function useLoader() {

    const loader = useContext(LoaderContext);

    return loader;
}